import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opModal copyableModal p-3 text-center" }
const _hoisted_2 = { class: "logoIcon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "body mt-2" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "form-control" }
const _hoisted_7 = { class: "mt-3 mw-700" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.$store.state.consts.projectConfig.logoUrl
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.text), 1),
        _createElementVNode("button", {
          class: "btn btn-primary btn-sm ms-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)))
        }, [
          (!_ctx.copied)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "Copia",
                text: "Copia"
              }))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "COPIATO",
                text: "COPIATO"
              }))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-block btn-primary noShadow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
        }, [
          _createElementVNode("span", { innerHTML: _ctx.okText }, null, 8, _hoisted_8)
        ])
      ])
    ])
  ]))
}